import React, { useState, useEffect } from "react";
import {
  CardTitle,
} from "reactstrap";
//redux
import { connect } from "react-redux";
//paginação
import Pagination from "../../../../components/Paginationv3";
// backdrops
import Alert from '../../../../components/Backdrops/Alert';
import Loading from '../../../../components/Backdrops/Loading';
// router
import { useLocation } from "react-router-dom";
//service
import reportService from "../../../../utils/services/accreditation/report";
import plusXMiceIdService from "../../../../utils/services/accreditation/plusXMiceId";
import PlusXMiceIdModel from '../../../../utils/models/PlusXMiceIdModel';
import writeXlsxFile from "write-excel-file";
import moment from 'moment';

import CommandButtons from './CommandButtons';
import EventNotActive from './EventNotActive';
import GuestsList from './GuestsList';

function ScheduleCheckinReport(props) {

  const location = useLocation();
  const eventId = location.state.idEvent;

  const [loadingControl, setLoadingControl] = useState({
    open: false,
    message: '',
  });
  const [alertControl, setAlertControl] = useState({
    open: false,
    title: '',
    message: '',
    status: '', // success, warning, error
  });
  const [plusXMiceId, setPlusXMiceId] = useState(PlusXMiceIdModel());
  const plusXMiceIdRef = React.useRef(PlusXMiceIdModel());
  const [guestsList, setGuestsList] = useState([]);
  // loading
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(1);
  const currentIndexRef = React.useRef(currentIndex);
  const isMountedRef = React.useRef(false);
  React.useEffect(() => {
    currentIndexRef.current = currentIndex;
    if (isMountedRef.current) {
      getData();
    }
  }, [currentIndex]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const itemsPerPageRef = React.useRef(itemsPerPage);
  React.useEffect(() => {
    itemsPerPageRef.current = itemsPerPage;
    if (isMountedRef.current) {
      getData();
    }
  }, [itemsPerPage]);

  useEffect(() => {
    isMountedRef.current = true;
    getData();
  }, []);

  const getData = React.useCallback(async () => {
    try {
      setLoadingControl({ ...loadingControl, open: true, message: 'Carregando' });

      let _plusXMiceId = { ...plusXMiceIdRef.current };
      if (!_plusXMiceId.miceId) {
        _plusXMiceId = await plusXMiceIdService.getPlusXMiceId(eventId);
        plusXMiceIdRef.current = _plusXMiceId;
        setPlusXMiceId(_plusXMiceId);
        if (!_plusXMiceId.active) {
          return;
        }
      }

      let _offset = (currentIndexRef.current - 1) * itemsPerPageRef.current;
      let _checkins = await reportService.getGuestSchedulesPass(
        _plusXMiceId.miceId,
        _offset,
        itemsPerPageRef.current,
      );

      setGuestsList(_checkins.data);
      setTotal(_checkins.count);

    } catch (error) {
      console.log('Error getData', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }
  }, []);

  const getReport = React.useCallback(async () => {
    try {
      setLoadingControl({ ...loadingControl, open: true, message: 'Buscando' });

      const _checkinsList = await getCheckinsList();

      await createXlsx(_checkinsList);

    } catch (error) {
      console.log('Error getData', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }

    async function getCheckinsList() {
      let _offset = 0;
      let _perPage = 500;
      let _checkinsList = [];
      let _checkinsCount = 0;
      do {
        let _checkins = await reportService.getGuestSchedulesPass(
          plusXMiceId.miceId,
          _offset,
          _perPage,
        );
        _offset += _perPage;
        _checkinsList = [..._checkinsList, ..._checkins.data];
        _checkinsCount = _checkins.count;

      } while (_checkinsCount > _offset);
      return _checkinsList;
    }

    async function createXlsx(list = []) {
      const schema = [
        {
          column: "ID",
          type: String,
          value: (checkin) => checkin.id.toString(),
        },
        {
          column: "Nome",
          type: String,
          value: (checkin) => checkin.nome,
        },
        {
          column: "E-mail",
          type: String,
          value: (checkin) => checkin.email,
        },
        {
          column: "Programação",
          type: String,
          value: (checkin) => checkin.tituloProgramacao,
        },
        {
          column: "Data do Check-in",
          type: String,
          value: (checkin) => checkin.dataRegistro,
        },
      ];

      await writeXlsxFile(list, {
        schema,
        fileName: `Relatório Check-ins Evento ${plusXMiceId.miceId} - ${moment().format('YYYY-MM-DD HH-MM')}.xlsx`,
      });
    }
  }, [plusXMiceId]);

  // busca a contagem de check-ins por programação de cada participante (pivot
  // participante x programação), paginando pelo endpoint getGuestSchedulesPassCount
  const getSchedulesCountReport = React.useCallback(async () => {
    try {
      setLoadingControl({ ...loadingControl, open: true, message: 'Buscando' });

      const _guestsList = await getGuestsCountList();

      await createXlsx(_guestsList);

    } catch (error) {
      console.log('Error getSchedulesCountReport', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }

    async function getGuestsCountList() {
      let _offset = 0;
      let _perPage = 500;
      let _guestsList = [];
      let _guestsCount = 0;
      do {
        let _ret = await reportService.getGuestSchedulesPassCount(
          plusXMiceId.miceId,
          '',
          _perPage,
          _offset,
        );
        _offset += _perPage;
        _guestsList = [..._guestsList, ..._ret.data];
        _guestsCount = _ret.count;

        if (_ret.data.length === 0) {
          break;
        }
      } while (_guestsCount > _guestsList.length);
      return _guestsList;
    }

    async function createXlsx(list = []) {
      if (list.length === 0) {
        throw new Error('Nenhum participante encontrado para gerar o relatório');
      }

      const _scheduleColumnsSet = new Set();
      list.forEach((guest) => {
        Object.keys(guest).forEach((key) => _scheduleColumnsSet.add(key));
      });
      const _scheduleColumns = [..._scheduleColumnsSet].filter(
        (key) => !['PaxId', 'Nome', 'Email'].includes(key),
      );

      const schema = [
        {
          column: "ID",
          type: String,
          value: (guest) => `${guest.PaxId}`,
        },
        {
          column: "Nome",
          type: String,
          value: (guest) => guest.Nome,
        },
        {
          column: "E-mail",
          type: String,
          value: (guest) => guest.Email,
        },
        ..._scheduleColumns.map((column) => ({
          column,
          type: Number,
          value: (guest) => guest[column] || 0,
        })),
      ];

      await writeXlsxFile(list, {
        schema,
        fileName: `Relatório Contagem de Check-ins Evento ${plusXMiceId.miceId} - ${moment().format('YYYY-MM-DD HH-MM')}.xlsx`,
      });
    }
  }, [plusXMiceId]);

  if (!plusXMiceId.active) {
    return (
      <EventNotActive />
    )
  }
  return (
    <div>
      <CardTitle>Relatório de Check-ins</CardTitle>
      <CommandButtons
        getReport={getReport}
        getSchedulesCountReport={getSchedulesCountReport}
      />
      <GuestsList
        guestsList={guestsList}
        loading={loading}
      />
      <Pagination
        data={guestsList}
        search={''}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        countData={total}
        maxItemPerPage={itemsPerPage}
        setMaxItemPerPage={setItemsPerPage}
        maxPageButtonsToShow={3}
      />

      <Loading loadingControl={loadingControl} />
      <Alert
        alertControl={alertControl}
        setAlertControl={setAlertControl}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(ScheduleCheckinReport);
